import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@quintoandar/cozy-core/Grid';
import Card from '@quintoandar/cozy-core/Card';
import { NavigationListItem } from '@quintoandar/cozy-core/List';
import LocationOnIcon from '@quintoandar/cozy-icons/LocationOn';

import { useAddressPredictions } from '../hooks/useAddressPredictions';

const ListPredications = ({ intl, input, latLng, handleClick }) => {
  const predictions = useAddressPredictions({ input, latLng });

  return <>
    {
      predictions.length > 0 && predictions.map((item, index) => {
        const handleClickPredication = () => {
          handleClick(intl.formatMessage(item.mainText));
        };

        return (<Grid container alignItems="center" justifyContent="center" key={`predication_${index}`}>
          <Grid item xs={12}>
            <Card noPadding>
              <NavigationListItem
                icon={item.icon}
                onClick={handleClickPredication}
                text={item.mainText}
                secondaryText={intl.formatMessage(item.secondaryText)}
                iconButtonArgsTable={{
                  ariaLabel: 'Icon Location',
                  icon: LocationOnIcon,
                }}
              />
            </Card>
          </Grid>
        </Grid>);
      })}
  </>;
};

ListPredications.propTypes = {
  intl: PropTypes.object,
  latLng: PropTypes.object,
  input: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
};

export default ListPredications;
